const prefillUtil = {
  //TODO: replace with switch statements where necessary?
  getPrefillProfileOptions(data, formName, schema) {
    let profiles = [];
    if (formName.indexOf("9141_old") > -1) {
      if (schema == "sectionBschemaNameHere") {
        if (data.EmployerPOCProfiles) {
          data.EmployerPOCProfiles.forEach((profile) => {
            profiles.push({
              id: profile.employer_poc_id,
              name: profile.employer_poc_name,
              type: "employer-pocs",
            });
          });
        }
        if (data.AgentIndividualProfiles) {
          data.AgentIndividualProfiles.forEach((profile) => {
            profiles.push({
              id: profile.agent_ind_id,
              name: profile.agent_ind_name,
              type: "agent-attorney-individs",
            });
          });
        }
      } else if (schema == "sectionCschemaNameHere") {
        if (data.EmployerProfiles) {
          data.EmployerProfiles.forEach((profile) => {
            profiles.push({
              id: profile.employer_id,
              name: profile.employer_name,
              type: "employer",
            });
          });
        }
      }
    } else if (formName.indexOf("9142B_old") > -1) {
      if (schema == "sectionDschemaNameHere") {
        if (data.EmployerPOCProfiles) {
          data.EmployerPOCProfiles.forEach((profile) => {
            profiles.push({
              id: profile.employer_poc_id,
              name: profile.employer_poc_name,
              type: "employer-pocs",
            });
          });
        }
      } else if (schema == "sectionEschemaNameHere") {
        if (data.AgentIndividualProfiles) {
          data.AgentIndividualProfiles.forEach((profile) => {
            profiles.push({
              id: profile.agent_ind_id,
              name: profile.agent_ind_name,
              type: "agent-attorney-individs",
            });
          });
        }
      } else if (schema == "appendixCforeignlaborSchemahere") {
        if (data.RecruiterProfiles) {
          data.RecruiterProfiles.forEach((profile) => {
            profiles.push({
              id: profile.recruiter_id,
              name: profile.recruiter_name,
              type: "foreign-labor",
            });
          });
        }
      }
    } else if (
      formName.includes("9141") ||
      formName.includes("790") ||
      formName.includes("9142A") ||
      formName.includes("9142B") ||
      formName.includes("9035") ||
      formName.includes("9089")
    ) {
      switch (schema) {
        case "employerProfiles":
          if (data.EmployersProfiles) {
            data.EmployerProfiles.forEach((profile) => {
              profiles.push({
                id: profile.employer_id,
                name: profile.employer_name,
                type: "employer",
              });
            });
          }
          break;
        case "employerPocs":
          if (data.EmployerPOCProfiles) {
            data.EmployerPOCProfiles.forEach((profile) => {
              profiles.push({
                id: profile.employer_poc_id,
                name: profile.employer_poc_name,
                type: "employer-pocs",
              });
            });
          }
          break;
        case "all":
          if (data) {
            if (data.EmployerProfiles && data.EmployerProfiles != undefined) {
              data.EmployerProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.employer_id,
                  name: profile.employer_name,
                  type: "employer",
                });
              });
            }
            if (
              data.EmployerPOCProfiles &&
              data.EmployerPOCProfiles != undefined
            ) {
              data.EmployerPOCProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.employer_poc_id,
                  name: profile.employer_poc_name,
                  type: "employer-pocs",
                });
              });
            }
            if (
              data.AgentIndividualProfiles &&
              data.AgentIndividualProfiles != undefined
            ) {
              data.AgentIndividualProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.agent_ind_id,
                  name: profile.agent_ind_name,
                  type: "agent-attorney-individs",
                });
              });
            }
            if (data.CropProfiles && data.CropProfiles != undefined) {
              data.CropProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.crop_id,
                  crop_id: profile.crop_crop_id,
                  name: profile.crop_name,
                  work_state: profile.crop_work_state,
                  crop_agricultural_activity:
                    profile.crop_agricultural_activity,
                  type: "crop",
                });
              });
            }
            if (
              data.AgricultureProfiles &&
              data.AgricultureProfiles != undefined
            ) {
              data.AgricultureProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.agriculture_id,
                  name: profile.agriculture_name,
                  agriculture_emp_name: profile.agriculture_emp_name,
                  agriculture_state: profile.agriculture_state,
                  agriculture_county: profile.agriculture_county,
                  type: "agriculture",
                });
              });
            }
            if (
              data.WorkerHousingProfiles &&
              data.WorkerHousingProfiles != undefined
            ) {
              data.WorkerHousingProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.workerHousing_id,
                  name: profile.workerHousing_name,
                  workerHousing_type_of_housing:
                    profile.workerHousing_type_of_housing,
                  workerHousing_state: profile.workerHousing_state,
                  workerHousing_county: profile.workerHousing_county,
                  type: "worker-housing",
                });
              });
            }
            if (
              data.MaterialTermsProfiles &&
              data.MaterialTermsProfiles != undefined
            ) {
              data.MaterialTermsProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.material_terms_id,
                  name: profile.material_terms_profile_name,
                  material_terms_section_number:
                    profile.material_terms_section_number,
                  material_terms_summary: profile.material_terms_summary,
                  material_terms_details: profile.material_terms_details,
                  type: "material-terms",
                });
              });
            }
            if (data.RecruiterProfiles && data.RecruiterProfiles != undefined) {
              data.RecruiterProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.recruiter_id,
                  name: profile.recruiter_name,
                  city: profile.city,
                  country: profile.country,
                  employer_name: profile.employer_name,
                  first_name: profile.first_name,
                  last_name: profile.last_name,
                  state: profile.state,
                  type: "foreign-labor",
                });
              });
            }
            if (
              data.ForeignWorkerProfiles &&
              data.ForeignWorkerProfiles != undefined
            ) {
              data.ForeignWorkerProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.foreign_worker_id,
                  name: profile.foreign_worker_name,
                  type: "foreign-worker",
                });
              });
            }
            if (
              data.ForeignWorkerGroupProfiles &&
              data.ForeignWorkerGroupProfiles != undefined
            ) {
              data.ForeignWorkerGroupProfiles.forEach((profile) => {
                profiles.push({
                  id: profile.foreign_worker_group_id,
                  name: profile.new_group_fw_group_name,
                  fw_profiles: profile.new_group_fw_profiles,
                  num_profiles: profile.new_group_fw_num_profiles,
                  type: "foreign-worker-group",
                });
              });
            }
          }
          break;
        default:
      }
    }
    return profiles;
  },

  getPrefillSchemaMapping(profileType, formDetailName, formSection) {
    if (formDetailName.indexOf("9141_old") > -1) {
      switch (formSection) {
        case "sectionBschemaNameHere":
          if (profileType === "employer-pocs") {
            return "employer-pocs-9141_old";
          }
          if (profileType === "agent-attorney-individs") {
            return "agent-attorney-9141";
          }
          break;
        case "sectionCschemaNameHere":
          if (profileType === "employer") {
            return "employer-9141";
          }
          break;
        default:
          return null;
      }
    } else if (formDetailName.indexOf("9141C") > -1) {
      switch (formSection) {
        case "B":
          if (profileType === "employer-pocs") {
            return "employer-pocs-9141C";
          }
          break;
        case "C":
          if (profileType === "employer") {
            return "employer-9141C";
          }
          break;
        default:
          return null;
      }
    } else if (formDetailName.indexOf("9141") > -1) {
      switch (formSection) {
        case "B":
          if (profileType === "employer-pocs") {
            return "employer-pocs-9141";
          }
          break;
        case "D":
          if (profileType === "agent-attorney-individs") {
            return "agent-attorney-9141";
          }
          break;
        case "C":
          if (profileType === "employer") {
            return "employer-9141";
          }
          break;
        default:
          return null;
      }
    } else if (formDetailName.indexOf("9142B") > -1) {
      switch (formSection) {
        case "D-1":
          if (profileType === "employer-pocs") {
            return "employer-pocs-9142B";
          }
          break;
        case "D-2":
          if (profileType === "agent-attorney-individs") {
            return "agent-to-employer-pocs-9142B";
          }
          break;
        case "E":
          if (profileType === "agent-attorney-individs") {
            return "agent-attorney-9142B";
          }
          break;
        case "Appx C":
          if (profileType === "foreign-labor") {
            return "foreign-labor-9142B";
          }
          break;
        default:
      }
    } else if (formDetailName.indexOf("790A") > -1) {
      switch (formSection) {
        case "II":
          if (profileType === "employer-pocs") {
            return "employer-pocs-790A";
          }
          if (profileType === "employer") {
            return "employer-790A";
          }
          break;
        default:
      }
    } else if (formDetailName.indexOf("9142A") > -1) {
      switch (formSection) {
        case "B":
          if (profileType === "employer") {
            return "employer-9142A";
          }
          break;
        case "C":
          if (profileType === "employer-pocs") {
            return "employer-pocs-9142A";
          }
          break;
        case "D":
          if (profileType === "agent-attorney-individs") {
            return "agent-attorney-9142A";
          }
          break;
        default:
      }
    } else if (formDetailName.indexOf("9035") > -1) {
      switch (formSection) {
        case "C":
          if (profileType === "employer") {
            return "employer-9035";
          }
          break;
        case "D":
          if (profileType === "employer-pocs") {
            return "employer-pocs-9035";
          }
          break;
        case "E":
          if (profileType === "agent-attorney-individs") {
            return "agent-attorney-9035";
          }
          break;
      }
    } else if (formDetailName.indexOf("9089") > -1) {
      switch (formSection) {
        case "A":
          if (profileType === "employer") {
            return "employer-9089";
          }
          break;
        case "B":
          if (profileType === "employer-pocs") {
            return "employer-pocs-9089";
          }
          break;
        case "C":
          if (profileType === "agent-attorney-individs") {
            return "agent-attorney-9089";
          }
        case "A.A":
          if (profileType === "foreign-worker") {
            return "foreign-worker-9089";
          }
          break;
        default:
          return null;
      }
    }
  },

  //TODO: combine with the resolve in the EditEntityModal??
  dataResolver(profileType) {
    const graphqlnamelist = {
      employer: { query: "getEmployerById", formDataName: "EmployerFormData" },
      "employer-pocs": { query: "getPOCById", formDataName: "POCFormData" },
      "agent-attorney": {
        query: "getAgentProfileById",
        formDataName: "AgentProfileFormData",
      },
      "agent-attorney-individs": {
        query: "getAgentById",
        formDataName: "AgentFormData",
      },
      "foreign-labor": {
        query: "getRecruiterById",
        formDataName: "RecruiterFormData",
      },
      "foreign-labors": {
        query: "getRecruiterByIds",
        formDataName: "RecruiterFormData",
      },
      crop: {
        query: "getCropById",
        formDataName: "CropFormData",
      },
      crops: {
        query: "getCropByIds",
        formDataName: "CropFormData",
      },
      agriculture: {
        query: "getAgricultureById",
        formDataName: "AgricultureFormData",
      },
      agricultures: {
        query: "getAgricultureByIds",
        formDataName: "AgricultureFormData",
      },
      "worker-housing": {
        query: "getWorkerHousingById",
        formDataName: "WorkerHousingFormData",
      },
      "worker-housings": {
        query: "getWorkerHousingByIds",
        formDataName: "WorkerHousingFormData",
      },
      "material-termss": {
        query: "getMaterialTermsByIds",
        formDataName: "MaterialTermsFormData",
      },
      "foreign-worker": {
        query: "getForeignWorkerById",
        formDataName: "ForeignWorkerFormData",
      },
    };
    return graphqlnamelist[profileType];
  },

  profileRowResolver(profileType, formApi, machine_name) {
    const formValues = formApi.getState().values;
    const { formVersionId } = formValues;
    const linkageIdResolver = ({
      linkageIdPrefix,
      formApi,
      machine_name,
      linkageMachineName,
    }) => {
      const formValues = formApi?.getState()?.values;
      let data = JSON.parse(JSON.stringify(formValues?.[machine_name] || []));

      // Always sort alphanumerically
      data?.sort((a, b) =>
        a?.[linkageMachineName]?.localeCompare(b?.[linkageMachineName], "en", {
          numeric: true,
        })
      );
      let linkageIdNumber = 1;
      const latestId = data?.[data?.length - 1]?.[linkageMachineName];

      if (latestId) {
        linkageIdNumber =
          parseInt(latestId?.replace(linkageIdPrefix, ""), 10) + 1;
      }
      return `${linkageIdPrefix}${linkageIdNumber}`;
    };

    const graphqlnamelist = {
      crops: function (field) {
        let data = field.CropFormData;
        let profileRow;

        // V2 Profiles
        if (formVersionId <= 2) {
          profileRow = {
            crop_id: data.new_profile_crop_crop_id,
            crop_name: data.new_profile_crop_crop_agricultural_activity,
            wage_offer: data.new_profile_crop_wage_offer,
            wage_per: data.new_profile_crop_per,
            additional_info: data.new_profile_crop_piece_rate_units,
          };
        } else {
          data.new_profile_crop_per = ["Hour", "Month"].includes(
            data.new_profile_crop_per
          )
            ? data.new_profile_crop_per
            : "";
          const error =
            !data?.new_profile_crop_crop_work_state ||
            !data?.new_profile_crop_crop_agricultural_activity ||
            !data?.new_profile_crop_wage_offer ||
            !data?.new_profile_crop_per ||
            !data?.new_profile_crop_piece_rate_offer ||
            !data?.new_profile_crop_piece_rate_units;

          const generatedCropId = linkageIdResolver({
            linkageIdPrefix: "A",
            linkageMachineName: "crop_id",
            formApi,
            machine_name,
          });

          profileRow = {
            crop_id: generatedCropId,
            addmaCropState: data.new_profile_crop_crop_work_state,
            crop_name: data.new_profile_crop_crop_agricultural_activity,
            wage_offer: data.new_profile_crop_wage_offer,
            wage_per: data.new_profile_crop_per,
            addmaPieceRate: data.new_profile_crop_piece_rate_offer,
            additional_info: data.new_profile_crop_piece_rate_units,
            error,
          };
        }

        return profileRow;
      },
      agricultures: function (field) {
        let data = field.AgricultureFormData;
        let profileRow = {
          business_name: data.new_profile_agriculture_emp_name,
          employment_address_1: data.new_profile_agriculture_worksite_address,
          employment_city: data.new_profile_agriculture_city,
          employment_state_id: data.new_profile_agriculture_state,
          employment_county_id: data.new_profile_agriculture_county,
          employment_zip: data.new_profile_agriculture_zip,
          additional_info: data.new_profile_agriculture_add_emp_info,
          begin_date: undefined,
          end_date: undefined,
          total_workers: undefined,
          error: true,
        };
        return profileRow;
      },
      "material-termss": function (field) {
        let data = field.MaterialTermsFormData;
        const convertToV3 = {
          "Meal Provision": "Provision of Meals",
          "Job Requirements": "Job Qualifications/Requirements",
          "Pay Deductions": "Deductions from Pay",
          "Referral and Hiring Instructions":
            "Other Material Terms and Conditions",
        };
        const convertToV2 = {
          "Provision of Meals": "Meal Provision",
          "Job Qualifications/Requirements": "Job Requirements",
          "Deductions from Pay": "Pay Deductions",
        };

        if (formVersionId === 3) {
          // Rename values from V2 to V3 values
          if (!!convertToV3[data?.new_profile_material_terms_section_number]) {
            data.new_profile_material_terms_section_number =
              convertToV3[data?.new_profile_material_terms_section_number];
          }

          // In V3, summary will match section number except when "Other Material Terms and Conditions"
          if (
            data.new_profile_material_terms_section_number !==
            "Other Material Terms and Conditions"
          ) {
            data.new_profile_material_terms_summary =
              data?.new_profile_material_terms_section_number;
          }
        } else if (formVersionId <= 2) {
          if (!!convertToV2[data?.new_profile_material_terms_section_number]) {
            data.new_profile_material_terms_section_number =
              convertToV2[data?.new_profile_material_terms_section_number];
          }
        }
        const error =
          formVersionId <= 2 &&
          data?.new_profile_material_terms_details?.length > 3500;

        let profileRow = {
          section_number: data.new_profile_material_terms_section_number,
          section_name: data.new_profile_material_terms_summary,
          section_details: data.new_profile_material_terms_details,
          error,
        };

        return profileRow;
      },
      "foreign-labors": function (field, form_id = null) {
        const data = field.RecruiterFormData;

        if (form_id === "9142A") {
          const error =
            !data?.new_profile_fl_recr_city ||
            !data?.new_profile_fl_recr_country_id ||
            !data?.new_profile_fl_recr_first_name ||
            !data?.new_profile_fl_recr_last_name ||
            !data?.new_profile_fl_recr_employer_name ||
            (data?.new_profile_fl_recr_country_id ===
              "UNITED STATES OF AMERICA" &&
              !data?.new_profile_fl_recr_state_id) ||
            !data?.new_profile_fl_recr_zip;
          return {
            city: data.new_profile_fl_recr_city,
            country: data.new_profile_fl_recr_country_id,
            firstName: data.new_profile_fl_recr_first_name,
            middleName: data.new_profile_fl_recr_middle_name ?? "N/A",
            lastName: data.new_profile_fl_recr_last_name,
            recBusinessName: data.new_profile_fl_recr_employer_name,
            state: data.new_profile_fl_recr_state_id,
            postalCode: data.new_profile_fl_recr_zip,
            province: data.new_profile_fl_recr_province ?? "N/A",
            registrationNumber1: data.new_profile_fl_recr_reg_num_1,
            registrationNumberCountry1:
              data.new_profile_fl_recr_reg_num_country_1,
            registrationNumber2: data.new_profile_fl_recr_reg_num_2,
            registrationNumberCountry2:
              data.new_profile_fl_recr_reg_num_country_2,
            registrationNumber3: data.new_profile_fl_recr_reg_num_3,
            registrationNumberCountry3:
              data.new_profile_fl_recr_reg_num_country_3,
            error,
          };
        } else {
          // Apply N/A if the state field is empty
          data.new_profile_fl_recr_state_id = data.new_profile_fl_recr_state_id
            ? data.new_profile_fl_recr_state_id
            : "N/A";

          const error =
            !data.new_profile_fl_recr_employer_name ||
            !data.new_profile_fl_recr_zip ||
            !data.new_profile_fl_recr_state_id;
          return {
            apdxcRecCity: data.new_profile_fl_recr_city,
            apdxcRecCountry: data.new_profile_fl_recr_country_id,
            apdxcRecFirstname: data.new_profile_fl_recr_first_name,
            apdxcRecMiddlename: data.new_profile_fl_recr_middle_name,
            apdxcRecLastname: data.new_profile_fl_recr_last_name,
            apdxcRecOrg: data.new_profile_fl_recr_employer_name,
            apdxcRecState: data.new_profile_fl_recr_state_id,
            apdxcRecPostcode: data.new_profile_fl_recr_zip,
            apdxcRecProvince: data.new_profile_fl_recr_province,
            error: error,
          };
        }
      },
      "worker-housings": function (field) {
        let data = field.WorkerHousingFormData;
        const requiredFields = [
          "new_profile_worker_housing_type_of_housing",
          "new_profile_worker_housing_physical_location_address",
          "new_profile_worker_housing_physical_location_state",
          "new_profile_worker_housing_physical_location_county",
          "new_profile_worker_housing_total_units",
          "new_profile_worker_housing_total_occupancy",
        ];
        if (
          !!data.new_profile_worker_housing_applicable_housing_standards_other
        ) {
          requiredFields.push(
            "new_profile_worker_housing_applicable_housing_standards_other_text"
          );
        }

        const requiredAtLeastOneTruthyField = [
          "new_profile_worker_housing_applicable_housing_standards_local",
          "new_profile_worker_housing_applicable_housing_standards_swa",
          "new_profile_worker_housing_applicable_housing_standards_other_state",
          "new_profile_worker_housing_applicable_housing_standards_other",
          "new_profile_worker_housing_applicable_housing_standards_federal",
        ];

        const error =
          requiredFields.some((field) => !data[field]) ||
          requiredAtLeastOneTruthyField.every((field) => !data[field]) ||
          (!!data.new_profile_worker_housing_additional_housing_information &&
            data.new_profile_worker_housing_additional_housing_information
              .length < 5) ||
          data["error"];
        let profileRow = {
          housing_type: data.new_profile_worker_housing_type_of_housing,
          housing_address_1:
            data.new_profile_worker_housing_physical_location_address,
          housing_city: data.new_profile_worker_housing_physical_location_city,
          housing_state_id:
            data.new_profile_worker_housing_physical_location_state,
          housing_county_id:
            data.new_profile_worker_housing_physical_location_county,
          housing_zip:
            data.new_profile_worker_housing_physical_location_zip_code,
          additional_info:
            data.new_profile_worker_housing_additional_housing_information,
          total_units: data.new_profile_worker_housing_total_units,
          total_occ: data.new_profile_worker_housing_total_occupancy,
          // applicable_housing_standards:
          //   data.new_profile_worker_housing_applicable_housing_standards,
          applicable_housing_standards_local:
            data.new_profile_worker_housing_applicable_housing_standards_local,
          applicable_housing_standards_swa:
            data.new_profile_worker_housing_applicable_housing_standards_swa,
          applicable_housing_standards_other_state:
            data.new_profile_worker_housing_applicable_housing_standards_other_state,
          applicable_housing_standards_other:
            data.new_profile_worker_housing_applicable_housing_standards_other,
          applicable_housing_standards_federal:
            data.new_profile_worker_housing_applicable_housing_standards_federal,
          applicable_housing_standards_other_text:
            data.new_profile_worker_housing_applicable_housing_standards_other_text,
          error,
        };
        return profileRow;
      },
    };
    return graphqlnamelist[profileType];
  },
};

export default prefillUtil;
